import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BasePatchProvider } from "@tendercuts/http";
import {
  GenerateWeeklyTripSheetResponse,
  WeeklyTripSheet,
} from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class WeeklyTripSheetConfirmService extends BasePatchProvider<
GenerateWeeklyTripSheetResponse
> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get key(): string {
    return "id";
  }

  get model(): typeof WeeklyTripSheet {
    return WeeklyTripSheet;
  }

  get endpoint(): string {
    return this.endpointService.updateWeeklyTripsheet();
  }

  get isCachable(): boolean {
    return false;
  }

  getConfirmParams(
    id: number,
  ): {
    status: number;
    id: number;
  } {
    const params: {
      status: number;
      id: number;
    } = {
      status: 2,
      id,
    };

    return params;
  }

  getApproveParams(
    id: number,
    comment: string,
  ): {
    status: number;
    request_incentive: boolean;
    id: number;
    comment: string;
  } {
    const params: {
      status: number;
      request_incentive: boolean;
      id: number;
      comment: string;
    } = {
      status: 1,
      request_incentive: true,
      id,
      comment,
    };

    return params;
  }
}
